<template>
  <div class="w-full py-3"
    v-if="broker != null"
    :style="'background-color:' + (broker.header_background != null ? broker.header_background : '#1A356F') + ';'">

    <div class="flex items-center justify-between w-full px-6 xxl:px-6 xxl:w-3/5 m-auto">
      <template v-if="broker.logo != null">
        <BrokerLogo v-bind:broker="broker" />
      </template>
      <template v-else>
        <BrokerpadLogo />
      </template>

      <!-- <div class="hidden lg:block text-center text-sm" :style="'color:' + (broker.header_text != null && broker.header_text == 1 ? '#000' : '#fff')">
        <div class="font-semibold">{{ broker.first_name }} {{ broker.last_name }}</div>
        <div class="">{{ broker.phone_mobile }}</div>
        <div class="-mt-1">
          <a :href="'mailto:' + broker.email" 
            class="underline"
            :style="'color:' + (broker.header_text != null && broker.header_text == 1 ? '#000' : '#fff')">{{ broker.email }}</a>
        </div>
      </div> -->

      <div class="flex items-center">        
        <template v-if="broker.profile_image != null">
          <img :src="broker.profile_image.url" class="rounded-full w-12 inline mr-4" />
        </template>
        <template v-else>
          <img src="https://noink.abs-cbn.com/no-profile-pic.png" class="rounded-full w-12 mr-4 inline" />
        </template>

        <template v-if="$store.state.view == 'broker'">
          <router-link :to="{
            name : 'broker-account',
            params : {
              brokerId : broker.id
            }
          }"
          tag="a"
          class="no-underline flex items-center"
          :style="'color:' + (broker.header_text != null && broker.header_text == 1 ? '#000' : '#fff') + ';'"
          v-tooltip.bottom="{ html : 'user-options', class : 'user-option-class' }">
            <div class="">
              <div class="text-sm font-semibold">{{ broker.first_name }} {{ broker.last_name }}</div>
              <div class="">{{ broker.phone_mobile }}</div>
              <div class="-mt-1">{{ broker.email }}</div>
            </div>
            <svg width="16" height="16" stroke-width="2" class="ml-4" stroke="currentColor" fill="none">
              <use xlink:href="/static/img/feather-sprite.svg#chevron-down"/>
            </svg>
          </router-link>
        </template>

        <template v-else>
          <div class="text-sm"
            :style="'color:' + (broker.header_text != null && broker.header_text == 1 ? '#000' : '#fff') + ';'">
            <div class="text-sm font-semibold">{{ broker.first_name }} {{ broker.last_name }}</div>
            <div class="">{{ broker.phone_mobile }}</div>
            <div class="-mt-1">{{ broker.email }}</div>
          </div>
        </template>
      </div>

      <div v-if="$store.state.view == 'broker'" id="user-options">
        <router-link :to="{
          name : 'broker-account',
          params : {
            brokerId : broker.id
          }
        }"
        tag="a"
        class="block text-sm text-white no-underline hover:underline">My account</router-link>

        <router-link :to="{
          name : 'broker-password',
          params : {
            brokerId : broker.id
          }
        }"
        tag="a"
        class="block text-sm text-white no-underline hover:underline">Password</router-link>

        <router-link :to="{
          name : 'broker-site-appearance',
          params : {
            brokerId : broker.id
          }
        }"
        tag="a"
        class="block text-sm text-white no-underline hover:underline">Site appearance</router-link>

        <router-link :to="{
          name : 'broker-mail-setting',
          params : {
            brokerId : broker.id
          }
        }"
        tag="a"
        v-if="!broker.suspended" href="/#/user/mail-settings"
        class="block text-sm text-white no-underline hover:underline">Mail settings</router-link>

        <router-link :to="{
          name : 'broker-payment',
          params : {
            brokerId : broker.id
          }
        }"
        tag="a"
        class="block text-sm text-white no-underline hover:underline">Payments</router-link>

<!--         <template v-if="showMercuryOption">
          <router-link :to="{
            name : 'broker-mercury',
            params : {
              brokerId : broker.id
            }
          }"
          tag="a"
          class="block text-sm text-white no-underline hover:underline">Mercury login</router-link>
        </template>
 -->
        <a href="#"
          v-on:click.prevent="logout()"
          class="block text-sm text-white no-underline hover:underline">Logout</a>
      </div>
    </div>
  </div>
</template>

<script>
  import BrokerLogo     from '../BrokerLogo';
  import BrokerpadLogo  from '../BrokerpadLogo';

  export default {

    components: {
      BrokerpadLogo,
      BrokerLogo
    },

    computed : {

      broker() {
        if(this.$route.params.brokerId != this.$store.state[this.$store.state.view + 'Module'].broker.id && this.$route.name == 'broker-site-appearance') {
          return this.$store.state[this.$store.state.view + 'Module'].brokerViaAdmin
        } else {
          return this.$store.state[this.$store.state.view + 'Module'].broker
        }
      },
    },
  }
</script>